<template><div>
<v-row>
  <v-col
    v-for="tag in tags" :key="tag.id"
    v-if="!tagUnderEdit(tag)"
  >
    <v-chip
      label
      :color="tagColor(tag)"
      @click="choose(tag)"
    >
      {{ tagText(tag) }}
    </v-chip>
  </v-col>
  <v-col v-if="!adding">
    <v-chip label outlined color="success" @click="addNewTag">Add Tags</v-chip>
  </v-col>
</v-row>
<v-row v-if="choosing">
  <v-col>
    <v-btn text @click="cancel">Cancel</v-btn>
    <v-btn text :to="choosingLink">See Films</v-btn>
    <v-btn text color="warning" @click="editChoice">Edit</v-btn>
  </v-col>
</v-row>
<v-row v-if="showEditBoxes">
  <v-col>
  <v-combobox
    v-model="selectedCategory"
    label="Category"
    outlined
    :disabled="!!editing"
    :items="categories"
    @input="categoryInput"
  />
  <v-combobox
    v-model="selectedTag"
    outlined
    label="Tag"
    :disabled="tagDisabled"
    :items="categoryTags"
  />
    <v-btn text @click="cancel">Cancel</v-btn>
    <v-btn
      v-if="adding"
      text
      color="success"
      :disabled="disableAdd"
      @click="add"
    >Add</v-btn>
    <v-btn
      v-if="editing"
      text
      color="info"
      :disabled="disableSave"
      @click="save"
    >Save</v-btn>
    <v-btn
      v-if="editing"
      text
      color="error"
      :disabled="disableRemove"
      @click="remove"
    >Remove</v-btn>
  </v-col>
</v-row>
</div></template>

<script>
// TODO: too much logic in the code above
export default {
  name: "FilmTags",
  props: {
    id: {
      type: String | Number,
      required: true,
    },
    tags: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      adding: false,
      choosing: null,
      editing: null,
      categories: [],
      selectedCategory: "",
      categoryTags: [],
      selectedTag: "",
      tagDisabled: true,
    }
  },
  inject: ["httpClient"],
  computed: {
    selectedTagAlreadyExists() {
      return this.tags.find(t =>
        t.category === this.selectedCategory &&
        t.tag === this.selectedTag) != null
    },
    disableSave() {
      if (!this.editing) return true
      if (!this.selectedTag) return true
      if (this.editing.tag === this.selectedTag) return true
      return this.selectedTagAlreadyExists
    },
    disableRemove() {
      if (!this.editing) return true
      return this.editing.tag !== this.selectedTag
    },
    disableAdd() {
      if (!this.adding) return true
      if (!this.selectedCategory || !this.selectedTag) return true
      return this.selectedTagAlreadyExists
    },
    choosingLink() {
      if (!this.choosing) return ""
      return {
        name: "Films",
        query: {
          tagged: `${this.choosing.category}:${this.choosing.tag}`
        },
      }
    },
    showEditBoxes() {
      return this.adding || this.editing
    },
  },
  methods: {
    reset() {
      this.selectedCategory = ""
      this.selectedTag = ""
      this.categories = []
      this.categoryTags = []
      this.adding = false
      this.choosing = null
      this.editing = null
      this.tagDisabled = true
    },
    tagUnderEdit(tag) {
      return this.editing && this.editing.id === tag.id
    },
    tagColor(tag) {
      return (this.choosing && this.choosing.id === tag.id) ? "info" : ""
    },
    tagText(tag) {
      const categoryText = tag.category === "default" ? "" : `${tag.category}: `
      return `${categoryText}${tag.tag}`
    },
    async addNewTag() {
      this.reset()
      this.categories = await this.httpClient.loadCategories()
      this.adding = true
    },
    async categoryInput(category) {
      this.categoryTags = await this.httpClient.loadTags({category})
      this.tagDisabled = false
    },
    choose(tag) {
      this.reset()
      this.choosing = tag
    },
    async editChoice() {
      this.categories = await this.httpClient.loadCategories()
      this.selectedCategory = this.choosing.category
      this.categoryTags = await this.httpClient.loadTags({
        category: this.selectedCategory
      })
      this.selectedTag = this.choosing.tag
      this.tagDisabled = false
      this.editing = this.choosing
      this.choosing = null
    },
    cancel() {
      this.reset()
    },
    async add() {
      const tag = await this.httpClient.addTag({
        id: this.id,
        category: this.selectedCategory,
        tag: this.selectedTag,
      })
      this.$emit("addTag", tag)
      this.reset()
    },
    async remove() {
      const tag = {...this.editing}
      await this.httpClient.removeTag({
        id: this.id,
        category: tag.category,
        tag: tag.tag,
      })
      this.$emit("removeTag", tag)
      this.reset()
    },
    async save() {
      const oldTag = {...this.editing}
      const newTag = await this.httpClient.editTag({
        id: this.id,
        category: this.selectedCategory,
        old_tag: oldTag.tag,
        new_tag: this.selectedTag,
      })
      this.$emit("editTag", {
        old_tag: oldTag,
        new_tag: newTag,
      })
      this.reset()
    },
  },
}
</script>
